import { Component } from '@angular/core';
import { WidgetComponentBase } from '../widget.class';

@Component({
  selector: 'app-widget-kokopu',
  templateUrl: './widget-kokopu.component.html',
  styleUrls: ['./widget-kokopu.component.scss'],
})
export class WidgetKokopuComponent extends WidgetComponentBase {}
